import { render, staticRenderFns } from "./SideResult.vue?vue&type=template&id=b88ea5be&"
import script from "./SideResult.vue?vue&type=script&lang=js&"
export * from "./SideResult.vue?vue&type=script&lang=js&"
import style0 from "./SideResult.vue?vue&type=style&index=0&id=b88ea5be&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports